import {
  BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, ResponsiveContainer, Legend,
} from "recharts";

const COLORS = ["var(--accent)", "#22c55e", "#f59e0b", "#ef4444", "#a855f7", "#06b6d4"];

export default function SummaryCharts({ summary }) {
  if (!summary) return null;

  const cols = Object.keys(summary.numeric_columns);
  if (cols.length === 0) {
    return (
      <p style={{ color: "var(--text-muted)", fontSize: 14, marginTop: 16 }}>
        Bu tabloda sayısal kolon bulunamadı.
      </p>
    );
  }

  const barData = cols.map((col, i) => ({
    name: col,
    Min: summary.numeric_columns[col].min ?? 0,
    Max: summary.numeric_columns[col].max ?? 0,
    Ortalama: parseFloat((summary.numeric_columns[col].mean ?? 0).toFixed(2)),
    color: COLORS[i % COLORS.length],
  }));

  const statCards = cols.slice(0, 6).map((col, i) => ({
    label: col,
    value: formatNum(summary.numeric_columns[col].sum),
    sub: `Ort: ${formatNum(summary.numeric_columns[col].mean)}`,
    color: COLORS[i % COLORS.length],
  }));

  return (
    <div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
          gap: 12,
          marginBottom: 28,
        }}
      >
        {statCards.map((card) => (
          <div
            key={card.label}
            style={{
              background: "var(--bg-card)",
              borderRadius: 10,
              padding: "14px 16px",
              borderLeft: `4px solid ${card.color}`,
            }}
          >
            <div style={{ color: "var(--text-secondary)", fontSize: 12, marginBottom: 4, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {card.label}
            </div>
            <div style={{ color: "var(--text-heading)", fontSize: 20, fontWeight: 700 }}>{card.value}</div>
            <div style={{ color: "var(--text-muted)", fontSize: 12, marginTop: 2 }}>{card.sub}</div>
          </div>
        ))}
      </div>

      <div style={{ background: "var(--bg-card)", borderRadius: 10, padding: 20, marginBottom: 20 }}>
        <h3 style={{ color: "var(--text-secondary)", fontSize: 14, marginBottom: 16, fontWeight: 600 }}>
          Min / Max / Ortalama Karşılaştırması
        </h3>
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={barData} margin={{ top: 0, right: 20, bottom: 40, left: 10 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
            <XAxis dataKey="name" tick={{ fill: "var(--text-secondary)", fontSize: 12 }} angle={-30} textAnchor="end" />
            <YAxis tick={{ fill: "var(--text-secondary)", fontSize: 12 }} />
            <Tooltip
              contentStyle={{ background: "var(--bg-page)", border: "1px solid var(--border)", borderRadius: 8 }}
              labelStyle={{ color: "var(--text-primary)" }}
            />
            <Legend wrapperStyle={{ color: "var(--text-secondary)", fontSize: 13 }} />
            <Bar dataKey="Min" fill="var(--accent)" radius={[4, 4, 0, 0]} />
            <Bar dataKey="Max" fill="#22c55e" radius={[4, 4, 0, 0]} />
            <Bar dataKey="Ortalama" fill="#f59e0b" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

function formatNum(val) {
  if (val === null || val === undefined) return "—";
  const n = parseFloat(val);
  if (Math.abs(n) >= 1_000_000) return (n / 1_000_000).toFixed(1) + "M";
  if (Math.abs(n) >= 1_000) return (n / 1_000).toFixed(1) + "K";
  return n.toFixed(2);
}
